import AuditableDocument from "./AuditableDocument";

// NPM
import moment from "moment";
import Joi from "joi";

export default class Medicare extends AuditableDocument {
	public static schema = Joi.object({
		medicareNumber: Joi.string()
			.required()
			.length(10)
			.label("Medicare number"),
		irn: Joi.number().min(1).required().label("IRN"),
		expiry: Joi.string().length(7).required().label("Expiry"),
	}).options({ abortEarly: false });

	public static numberIsValid(medicareNum: string): boolean {
		if (medicareNum.length < 10) {
			return false;
		}
		return true;
	}

	public static numberIsInvalid(medicareNum: string): boolean {
		return !Medicare.numberIsValid(medicareNum);
	}

	/**
	 * DO NOT USE YET
	 * @param input
	 * @param requiredLength
	 * @returns
	 */
	public static formatExpiry(
		input: string,
		requiredLength: 7 | 10 = 7
	): string {
		const expiry = super.formatExpiry(input, requiredLength);
		return moment(expiry).format("MM/yyyy");
	}
}
